<template>
    <img
        v-if="status === 'registered'"
        src="/images/icons/registered-icon.svg"
        alt="Зарегистрирован"
        class="registered-icon"
        :class="sizeClass"
    />
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    status: {
        type: String,
        default: null,
    },
    size: {
        type: String,
        default: 'md', // sm | md
        validator: (value) => ['sm', 'md'].includes(value),
    },
});

const sizeClass = computed(() => `registered-icon--${props.size}`);
</script>

<style scoped>
.registered-icon {
    display: inline-block;
    flex-shrink: 0;
    vertical-align: middle;
}

.registered-icon--sm {
    width: 14px;
    height: 14px;
}

.registered-icon--md {
    width: 16px;
    height: 16px;
}
</style>
